import React, {
  useState,
  useContext,
  useEffect,
  memo,
  createRef,
  useMemo,
} from "react";
import Draggable from "react-draggable";
// eslint-disable-next-line
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../../Context/Auth/AuthContext";
import clienteAxios from "../../../../config/axios";
import {
  validarDocumento,
  // validarDocumento,
  validarEmail,
} from "../../../../config/validaciones";

import { Check, Download, Map, Search } from "@mui/icons-material";

import {
  getMonths,
  FechaExacta,
  navegadorCompatible,
  replaceCaracteres,
  trimPropsItem,
} from "../../../../config/const";
import {
  Typography,
  Button,
  LinearProgress,
  linearProgressClasses,
  RadioGroup,
  Radio,
} from "@mui/material";
import Turnos from "./Turnos";
// import Dropzone from "../../../components/Dropzone";
// MATERIAL
import {
  Modal,
  Box,
  Divider,
  IconButton,
  FormControlLabel,
  Switch,
  TextField,
  MenuItem,
  FormControl,
  InputAdornment,
  InputLabel,
  Select,
  Input,
  Chip,
  useTheme,
  Avatar,
  Tooltip,
  Paper,
  Table,
  TableContainer,
  TablePagination,
  TableBody,
  TableHead,
  // Slide,
  // Grow,
  Autocomplete,
} from "@mui/material";
import {
  AddCircle,
  Cancel,
  Delete,
  CloudUpload,
  // CloudDownload,
} from "@mui/icons-material";
import { useModalStyle } from "../../../../styles/styleModal";
import { objectDefault } from "../data";
import useMultimediasUpload from "../../../../hooks/useMultimediasUpload";
import ConfirmacionDialog from "../../../components/Dialogs/ConfirmacionDialog";
import ToolBarTable from "../../../components/Tablas/ToolBarTable";
import { useSimpleTable } from "../../../../hooks/useSimpleTable";
import TablaCabecera from "../../../components/Tablas/TablaCabecera";
import RowHorario from "./Horario/RowHorario";
import { v4 } from "uuid";

function getModalStyle() {
  return {
    borderRadius: "15px",
    position: "absolute",
    overflow: "scroll",
    maxHeight: "95vh",
  };
}

export const ModalPersonas = (props) => {
  const {
    editar,
    seteditar,
    setopen,
    open,
    ObjectoActivo,
    changeObjetoActivoState,
    socket,
    estadoRequest,
    fromAvisoSalida,
  } = props;
  const [openMap, setopenMap] = useState(false);
  const [clientesDataLaborales, setclientesDataLaborales] = useState([]);
  const [clientesData, setclientesData] = useState([]);
  const [clienteProveedor, setclienteProveedor] = useState("GUARDIAS");
  const [bancos, setbancos] = useState(null);
  const [lugaresTrabajoData, setlugaresTrabajoData] = useState(null);
  const [ciudadesData, setciudadesData] = useState(null);
  const [documentosArray, setdocumentosArray] = useState([]);
  const [documentosObject, setdocumentosObject] = useState({});
  const [objetoReferencias, setobjetoReferencias] = useState({});
  const [item, setitem] = useState(ObjectoActivo);
  const [cargando, setcargando] = useState(false);
  const [agregandoBodega, setagregandoBodega] = useState(false);
  const [agregandoDescuento, setagregandoDescuento] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [archivoFoto, setarchivoFoto] = useState("");
  const [imagenMostradaFoto, setimagenMostradaFoto] = useState(null);
  const [archivoCarnet, setarchivoCarnet] = useState("");
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  const {
    setmodificoImagenes,
    subirImagenes,
    imagenes,
    setimagenes,
  } = useMultimediasUpload();
  const [error, seterror] = useState({});
  const [modalStyle] = useState(getModalStyle);
  const [seccionActive, setseccionActive] = useState({
    DatosGenerales: false,
    PuestoServicio: false,

    DatosLaborales: true,
    HorarioIncapaciad: false,
    Bonos: false,
    TurnosSeccion: false,
    FotografiasSeccion: false,
  });

  const defaultActive = () => {
    // setdocSearch("");
    changeObjetoActivoState(objectDefault);
    setopen(false);
    seteditar(false);
    seterror({});
    setseccionActive({
      DatosGenerales: false,
      PuestoServicio: false,
      DatosLaborales: true,
      HorarioIncapaciad: false,
      Bonos: false,
      TurnosSeccion: false,
    });
    setseccionActiveDatosL({
      DatosPrincipales: false,
      TurnosLaborales: true,
    });
    setcargando(false);
    setarchivoCarnet("");
    setarchivoFoto("");
    setimagenMostradaFoto(null);
    setobjetoReferencias(null);
    setdocumentosObject(null);
    setclientesData([]);
    setimagenes([]);
    setmodificoImagenes(false);
    setopenConfirmDialog(false);
  };
  const submit = () => {
    if (true) {
      return false;
    } else {
      return true;
    }
  };
  const sinValidacion = useMemo(
    () => editar && ObjectoActivo.perEstado !== item.perEstado,
    [item, ObjectoActivo, editar]
  );
  const validacion = () => {
    if (sinValidacion) {
      return false;
    }

    if (
      horarios.length === 0 ||
      item.horarios.some((item) => {
        return (
          item.clienteIngreso === "" ||
          item.idClienteIngreso === "" ||
          item.docClienteIngreso === "" ||
          item.puestoIngreso === "" ||
          item.clienteSalida === "" ||
          item.idClienteSalida === "" ||
          item.docClienteSalida === "" ||
          item.puestoSalida === "" ||
          item.turno === "" ||
          item.ingreso === "" ||
          item.salida === "" ||
          item.fechas_milisegundos.length === 0 ||
          item.fechas_iso.length === 0
        );
      })
    ) {
      mostrarAlerta("Faltan datos obligatorios por llenar", "error");
      seterror({
        horarios:
          horarios.length === 0 ||
          item.horarios.some((item) => {
            return (
              item.clienteIngreso === "" ||
              item.idClienteIngreso === "" ||
              item.docClienteIngreso === "" ||
              item.puestoIngreso === "" ||
              item.clienteSalida === "" ||
              item.idClienteSalida === "" ||
              item.docClienteSalida === "" ||
              item.puestoSalida === "" ||
              item.turno === "" ||
              item.ingreso === "" ||
              item.salida === "" ||
              item.fechas_milisegundos.length === 0 ||
              item.fechas_iso.length === 0
            );
          })
            ? true
            : false,
      });
      return true;
    } else {
      return false;
    }
  };

  // eslint-disable-next-line
  const { mostrarAlerta } = useContext(AlertaContext);
  // eslint-disable-next-line
  const { usuario } = useContext(AuthContext);
  //props

  // eslint-disable-next-line

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
  };

  // eslint-disable-next-line

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  // eslint-disable-next-line

  //foto

  const onChangeFileFoto = (e) => {
    if (!e.target.files[0]) {
      setimagenMostradaFoto(null);
      return setarchivoFoto("");
    }

    if (
      !["png", "jpg", "jpeg"].some(
        (item) => item === e.target.files[0].type.split("/")[1]
      )
    ) {
      setimagenMostradaFoto(null);
      setarchivoFoto("");
      return mostrarAlerta("Solo archivos png, jpg o jpeg", "error");
    }

    setarchivoFoto(e.target.files[0]);
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = (e) => {
      e.preventDefault();
      setimagenMostradaFoto(e.target.result);
    };
  };
  //Carnet

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  function getStylesEspecialidades(name, permisos, theme) {
    return {
      fontWeight:
        permisos.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
      backgroundColor: permisos.indexOf(name) === -1 ? "white" : "#31b2f7",
    };
  }

  const theme = useTheme();
  useEffect(() => {
    setclienteProveedor(estadoRequest);

    const getData = async () => {
      setitem({
        ...ObjectoActivo,
      });
    };
    getData();
    // eslint-disable-next-line
  }, [ObjectoActivo, open]);
  const [ubicacionesData, setubicacionesData] = useState([]);
  const getubicacionesData = async () => {
    try {
      const res = await clienteAxios.get(`/ubicaciones_trabajo/todo`);
      console.log({ res });

      setubicacionesData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getubicacionesData();
  }, []);

  useEffect(() => {
    if (!bancos || lugaresTrabajoData) {
      try {
        const getData = async () => {
          const resBancos = await clienteAxios.get(`/bancos/filtro/0`);

          setbancos(resBancos.data.data);

          const resLugaresTrabajo = await clienteAxios.get(
            `/lugartrabajo/filtro/0`
          );

          setlugaresTrabajoData(resLugaresTrabajo.data.data);
          const resCiudades = await clienteAxios.get(`/ciudades/filtro/0`);

          setciudadesData(resCiudades.data.data);
        };
        getData();
      } catch (error) {}
    } // eslint-disable-next-line
  }, []);
  // eslint-disable-next-line
  const {
    // perPerfil,
    // perDocTipo,
    perDocNumero,

    perFoto,
    horarios,

    //docs
    documentos,
    perUbicacion,
  } = item;
  // eslint-disable-next-line

  // eslint-disable-next-line
  const handleChange = (e) => {
    const res = replaceCaracteres(e.target.value);

    setitem({
      ...item,
      [e.target.name]: res,
    });
  };

  //hook de estilos
  const clases = useModalStyle();
  //definiendo los estilos del modal

  const { DatosLaborales } = seccionActive;

  const [seccionActiveDatosL, setseccionActiveDatosL] = useState({
    TurnosLaborales: true,
  });
  const { TurnosLaborales } = seccionActiveDatosL;

  console.log({ item });

  useEffect(() => {
    const resTurnos = item.horarios.map((itemTurno) => {
      if (
        itemTurno.fechas_milisegundos &&
        itemTurno.fechas_iso &&
        itemTurno.id
      ) {
        return {
          ...itemTurno,
          fechas_iso:
            itemTurno.fechas_iso.length > 0 && itemTurno.salida
              ? []
              : itemTurno.fechas_iso,
        };
      } else {
        return {
          ...itemTurno,
          fechas_milisegundos: [],
          fechas_iso: [],
          id: v4(),
        };
      }
    });
    setitem({
      ...item,
      horarios: resTurnos,
    });
    setcargando(false);
    // eslint-disable-next-line
  }, []);
  const handleEditar = async () => {
    if (validacion()) {
      return;
    }

    try {
      setcargando(true);

      const horariosConId = item.horarios.map((horario) => {
        const antiguo = ObjectoActivo.horarios.find(
          (h) => h.id === horario.id
        );
        if (!antiguo) return horario;
        return {
          ...horario,
          fechas_iso: horario.fechas_iso.map((fecha) => {
            const match = antiguo.fechas_iso.find(
              (f) => f.desde === fecha.desde && f.hasta === fecha.hasta && f.id
            );
            if (match) {
              return { ...fecha, id: match.id };
            }
            return fecha;
          }),
        };
      });

      const itemEnv = trimPropsItem({
        perId: item.perId,
        horarios: horariosConId,

        //params
        horario_antiguo: ObjectoActivo.horarios,
        rol: usuario.rol,
        rucempresa: usuario.rucempresa,
        tabla: "horarios",
      });
      console.log({ itemEnv });
      socket.current.emit("client:actualizarData", itemEnv);
      setcargando(false);
      return defaultActive();
    } catch (error) {
      console.log({ error });
      setcargando(false);

      mostrarAlerta("Hubo un error", "error");
      return defaultActive();
    }
  };

  // eslint-disable-next-line

  const {
    // agregandoTurno,
    // setagregandoTurno,
    pageTurno,
    // setPageTurno,
    rowsPerPageTurno,
    // setRowsPerPageTurno,
    handleChangePageTurno,
    handleChangeRowsPerPageTurno,
  } = useSimpleTable("Turno");
  // SECCION
  if (!open) {
    return null;
  }

  // if (!bancos) {
  //   return null;
  // }
  // if (!ciudadesData) {
  //   return null;
  // }
  // if (!lugaresTrabajoData) {
  //   return null;
  // }

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <ConfirmacionDialog
          open={openConfirmDialog}
          setopen={setopenConfirmDialog}
          categoria="warning"
          titulo={`${
            cargando
              ? "Cargando: "
              : `¿Esta seguro de ${editar ? "editar" : "crear"} este usuario ${
                  item.perNombre
                }`
          } ${
            clienteProveedor === "GUARDIAS"
              ? "Guardia"
              : clienteProveedor === "SUPERVISORES"
              ? "Supervisor"
              : clienteProveedor === "ADMINISTRACIÓN"
              ? "Administración"
              : ""
          } ${cargando ? "" : "?"}`}
          botones={[
            {
              tooltip: `Se  ${editar ? "editara" : "creara"} el registro`,
              texto: "SI",
              funcion: () => {
                if (editar) {
                  handleEditar();
                } else {
                }
              },
              disabled: cargando,
              Icon: Check,
              color: "success",
              id: 1,
              ocultar: false,
              tipo: "boton",
              variante: "contained",
              size: "medium",
              sx: { marginRight: ".3rem" },
            },
            {
              tooltip: "Cancelar",
              texto: "NO",
              funcion: () => {
                setopenConfirmDialog(false);
              },
              disabled: cargando,
              Icon: Cancel,
              color: "error",
              id: 2,
              ocultar: false,
              tipo: "boton",
              variante: "contained",
              size: "medium",
              sx: {},
            },
          ]}
        />
        <Draggable handle="#handle">
          <Box display="flex" justifyContent="center">
            <div style={modalStyle} className={clases.paper}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <Typography
                  id="handle"
                  style={{ cursor: "-webkit-grab" }}
                  variant="button"
                  color="initial"
                  align="center"
                >
                  {editar ? "Editar " : "Agregar "}
                  {"Horario"}.
                </Typography>
                <Typography variant="h9" color="initial" align="center">
                  {item.perId} --- {`${item.perDocNumero} ${item.perNombre}`}
                </Typography>
                <Box display="flex" alignItems="center">
                  <IconButton
                    aria-label=""
                    style={{ margin: "0px" }}
                    onClick={() => {
                      defaultActive();
                    }}
                  >
                    <Cancel color="secondary" />
                  </IconButton>
                </Box>
              </Box>
              <Divider />
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems=" stretch"
                width="100%"
              >
                <Box display="flex" flexWrap={"wrap"}></Box>
                <Box></Box>
              </Box>
              <Divider />
              <Box className={clases.container}>
                {DatosLaborales ? (
                  <>
                    <Divider className={clases.formAllW}>
                      <Typography variant="subtitle1" color="secondary">
                        Horarios y turnos
                      </Typography>
                    </Divider>{" "}
                    <Paper sx={{ width: "100%" }}>
                      <ToolBarTable
                        count={horarios.length}
                        rowsPerPage={rowsPerPageTurno}
                        page={pageTurno}
                        handleChangePage={handleChangePageTurno}
                        handleChangeRowsPerPage={handleChangeRowsPerPageTurno}
                        ocultarPaginacion={false}
                        simplePagination={true}
                        botonesIzquierdos={[
                          {
                            tooltip: "Agregar",
                            texto: "Agregar",
                            funcion: () => {
                              const existeVacio = item.horarios.some((item) => {
                                console.log(
                                  item.ubicacion,
                                  item.fechas_milisegundos,
                                  item.fechas_iso
                                );
                                return (
                                  item.ubicacion === "" ||
                                  item.fechas_milisegundos.length === 0 ||
                                  item.fechas_iso.length === 0
                                );
                              });

                              if (existeVacio) {
                                return mostrarAlerta(
                                  "Complete todos los campos.",
                                  "error"
                                );
                              }
                              setitem({
                                ...item,
                                horarios: [
                                  ...item.horarios,
                                  {
                                    id_horario_ubicacion: 0,
                                    ubicacion: "",
                                    puesto: "",

                                    fechas_milisegundos: [],
                                    fechas_iso: [],
                                    id: v4(),
                                  },
                                ],
                              });
                            },
                            disabled: false,
                            Icon: AddCircle,
                            color: "primary",
                            id: 1,
                            ocultar: false,
                            tipo: "boton",
                            variante: "contained",
                            size: "medium",
                            sx: {},
                          },
                        ]}
                        botonesDerechos={[]}
                      />

                      <TableContainer>
                        <Table
                          stickyHeader
                          aria-label="sticky table"
                          size="small"
                        >
                          <TableHead>
                            <TablaCabecera
                              columns={[
                                {
                                  id: "Ubicación",
                                  label: "Ubicación",
                                  minWidth: 200,
                                },
                                {
                                  id: "Fechas",
                                  label: "Fechas",
                                  minWidth: 200,
                                },
                              ]}
                              habilitarOrdenar={false}
                            />
                          </TableHead>

                          <TableBody component={"div"}>
                            {horarios
                              .sort((a, b) => {
                                const fechaA =
                                  a.fechas_milisegundos[0]?.desde || 0; // Si no hay fecha, usar 0
                                const fechaB =
                                  b.fechas_milisegundos[0]?.desde || 0;

                                // Si `fechas_milisegundos` está vacío, ponerlo primero
                                if (a.fechas_milisegundos.length === 0)
                                  return -1;
                                if (b.fechas_milisegundos.length === 0)
                                  return 1;

                                // Ordenar por fecha de más reciente a más antiguo
                                return fechaB - fechaA;
                              })
                              .map((rowHijo, index) => {
                                return (
                                  <RowHorario 
                                    ubicacionesData={ubicacionesData}
                                    editarPadre={editar}
                                    setitemPadre={setitem}
                                    itemPadre={item}
                                    rowHijo={rowHijo}
                                    index={index}
                                    key={rowHijo.id}
                                  />
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </>
                ) : null}
              </Box>
              {cargando && <LinearProgress />}
              {/* <Divider /> */}
              <Box
                display="flex"
                width="100%"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                ></Box>
                <Typography
                  variant="h9"
                  color="initial"
                  align="center"
                  width={"100%"}
                ></Typography>
                <Box
                  width="50%"
                  display="flex"
                  justifyContent="flex-end"
                  mt={1}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    disabled={submit() || cargando}
                    onClick={() => {
                      setopenConfirmDialog(true);
                    }}
                  >
                    Guardar
                  </Button>
                </Box>
              </Box>
            </div>
          </Box>
        </Draggable>
      </Box>
    </Modal>
  );
};

export default memo(ModalPersonas);
